import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import generalReducer, { setCurrentPage } from "./generalSlice";
import authReducer from "./authSlice";
import filtersReducer from "./filtersSlice";
import { persistReducer } from "redux-persist";
import tabsSlice from "./tabsSlice";
import moduleReducers, { middlewares as moduleMiddleware, rtkqReducers } from "../modules/redux";
import headerSlice from "./headerSlice";
import expertSlice from "./expertSlice";
import { notificationsApi } from "./service/notifications";
// import stepSlice from '../modules/pvs_activities/pages/stepSlice'

const reducers = combineReducers({
    general: generalReducer,
    auth: authReducer,
    filters: filtersReducer,
    tabs: tabsSlice,
    header: headerSlice,
    expert: expertSlice,

    ...moduleReducers,
    ...rtkqReducers,
    // Add reducers of your RTKQ
    [notificationsApi.reducerPath]: notificationsApi.reducer,
});

const allMiddlewares = [
    ...moduleMiddleware,
    notificationsApi.middleware
];

const persistConfig = {
    key: "pvsis",
    storage,
    blacklist: [
        // Add Names of your RTKQ reducers
        ...Object.keys(rtkqReducers),
        notificationsApi.reducerPath
    ],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }).concat(allMiddlewares),
    devTools: true,
});

export const resetCurrentPage = () => {
    store.dispatch(setCurrentPage(""));
    return null;
};
